module.exports = __webpack_public_path__ + "img/21.07a299c6.png";